import React from 'react';

const HelpFAQ = () => {
  return (
    <div>
      <h1>Help/FAQ</h1>
      <h2>How does VetBill work?</h2>
      <p>VetBill allows users to ...</p>
      {/* Add more questions and answers as needed */}
    </div>
  );
};

export default HelpFAQ;
